import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiWPPlaylistsResponseBody } from '../WPPlaylistsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseWPPlaylistsQueryValues = {
  appId: string;
};

export const wpPlaylistsQueryKeyFactory: IQueryKeyFactory<
  IUseWPPlaylistsQueryValues
> = (values) => values && (['wpPlaylists', values.appId] as const);

export const useWPPlaylistsQuery = (
  values?: IUseWPPlaylistsQueryValues,
  options?: UseQueryOptions<IApiWPPlaylistsResponseBody, ApiError>,
): UseQueryResult<IApiWPPlaylistsResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: wpPlaylistsQueryKeyFactory(values),
    queryFn: values ? () => api.wpPlaylists.getAll(values.appId) : undefined,
    ...options,
  });
};
